import urls from "../../common/js/urls";


const ads_config = {
    all_ads: [],
    olx_ads: [],
    accounts: [],
    rareData: {
        categories: {url: urls.category, data: []},
        regions: {url: urls.regions, data: []},
        districts: {url: urls.districts, data: []},
    },
    CATEGORIES: [],
    all_regions: [],
    all_cities: [],
    all_districts: [],
    filteredAds: [],
    all_bots: [],
    all_connections: [],
    dataToConnect: [],
    dataToDisconnect: [],
    dataToConnectBulk: [],
    dataToDisconnectBulk: [],
    emptyConnections: [],
    cityIdsToUpdate: [],
    currencies_rates: {},
    currencies: {
        'UAH': 'грн.',
        'USD': '$',
        'EUR': '€',
        'PLN': 'zł',
        'RON': 'lei',
        'BGN': 'лв.',
        'KZT': 'тг.',
    }
};
let selectors = {
    accounts: '#accounts-select',
    botPresenceFilter: '#bot-presence-select',
    botIdsFilter: '#bot-id-select',
    categories: '#categories-select',
    newBotFilter: '#newBotFilter2',
    adsList: '#inventory-list',
    bulkContainer: '#bulk_container'
};


export {ads_config, selectors};
